import produce from 'immer';
import * as types from './types';

const initialState = {
  sites: [],
  site: {},
};

const siteReducers = function(state = initialState, action) {
  const { type, payload } = action;

  return produce(state, draft => {
    switch (type) {
      case types.GET_SITES_COMPLETED:
        draft.sites = payload;
        break;
      case types.GET_SITE_COMPLETED:
        draft.site = payload;
        break;
      case types.CREATE_SITE_COMPLETED:
        draft.sites.unshift(payload);
        break;
      case types.UPDATE_SITE_COMPLETED:
        draft.site = payload;
        break;
      default:
        return state;
    }
  });
};

export default siteReducers;
